module.exports = __webpack_public_path__ + "static/c-2247f0e2d9f2031f94950e3ac5e97e4c.png";